import React from 'react'
import LandingSlider from '../components/LandingSlider'
import Services from '../components/Services'
import Yelp from '../components/Yelp'

export default function Landing() {

  return (
    <>
      <LandingSlider />
      <Services showDetails={false}
      customDetails="For over 16 years, Dollhouse Mermaid has delivered luxury makeup experiences for brides, professionals, and creatives who expect perfection — from skin prep to final detail. This is makeup that photographs beautifully, lasts all day, and feels effortlessly you."
      />
      <Yelp />
    </>
  )
}